import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

import { Pagination } from './pagination.types'
import { Error } from './error.types'

interface MedicationData {
  id: number
  commercial_name: string
  generic_name: string
}

interface ListMedicationsData {
  medications: MedicationData[]
  pagination: Pagination
}

interface Medication {
  id: number
  commercialName: string
  genericName: string
}

interface ListMedicationsResponse {
  medications: Medication[]
  pagination: Pagination
}

export const listMedications = (query?: string, page?: number): Promise<ListMedicationsResponse> => {
  const endpoint = apiEndpoints.MEDICAL_RECORDS_MEDICATIONS

  const params = {
    per_page: 10,
    ...(query && { query }),
    ...(page && { page }),
  }

  return new Promise<ListMedicationsResponse> ((resolve, reject) => {
    axios.get<ListMedicationsData>(endpoint, { params })
      .then(response => {
        const medications = response.data.medications.map(medication => {
          return {
            commercialName: medication.commercial_name,
            id: medication.id,
            genericName: medication.generic_name,
          } as Medication
        })

        const pagination = response.data.pagination

        resolve({
          medications,
          pagination,
        })
      })
      .catch((error: Error) => 
        reject(error?.response?.status)
      )
  })
}